/*
 *  Class ScrollTop
 */
export
default class Scroll {
    constructor() {
        this.body = document.body;
        this.offset = document.querySelector('.header') ? document.querySelector('.header').offsetHeight : null;
    }

    handleState() {
        if (window.scrollY > this.offset) {
            this.body.classList.add('js-scrolled');

        } else {
            this.body.classList.remove('js-scrolled');
        }
    }

    init() {
        window.addEventListener('scroll', this.handleState.bind(this));
        this.handleState();
    }
}
